export const blockIconsCommunicationChatNew = (
	<span className='material-symbols-outlined'>chat</span>
);
